module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/bcyR23/tc-custom/9781035832316.jpg?1718106147032",
      "alt": "This image is the cover for the book The Eternal Effo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Eternal Effo\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Eternal Effo: How to Avoid a Career in Aviation offers an insightful and often humorous look at a three-decade journey in commercial aviation. This memoir is not about the high-flying life of fighter pilots, test pilots, Concorde captains or astronauts. Instead, it’s a candid exploration of a less glamorous but no less eventful and enjoyable career in the skies. In these pages, the author shares the lighter side of aviation, from amusing anecdotes to the unexpected joys of the job, as he successfully navigates the industry into retirement. This book is for anyone who’s ever been curious about the realities of a career in aviation, minus the typical heroics and high-octane adventures. It’s a testament to the day-to-day effort and perseverance required to stay aloft in this challenging field.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Steve Gatley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("An airline pilot for nearly 30 years, now thankfully retired, Steve lives quietly at home with his wife and does whatever he is told, unless he doesn’t feel like it, such as more travelling or walking the dog when it’s raining.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0